import React, { useEffect, useState } from 'react';
import { AnimatePresence, m as motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('top');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting);
    }, {
      threshold: 0,
      rootMargin: '-200px 0px 0px 0px'
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  const show = visible && !dismissed;
  return <AnimatePresence data-id="element-256" data-mp="1arowy4vfhom8">
      {show && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-mp-border bg-mp-black/95 px-4 py-3 backdrop-blur-md md:hidden" data-id="element-257" data-mp="1asqk37ppy1kb">
          <div className="flex items-center justify-between gap-3" data-id="element-258" data-mp="2s2258ihv9tms">
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-mp-gray" data-id="element-259" data-mp="2n1o1hcnat5uk">
              <XIcon className="h-4 w-4" data-id="element-260" data-mp="29a9bumyvy6ej" />
            </button>
            <div className="flex-1 min-w-0" data-id="element-261" data-mp="297db6qvnl3me">
              <p className="truncate font-heading text-xs uppercase tracking-wide text-mp-white" data-id="element-262" data-mp="24adcx251p55u">Maestro en Pista</p>
              <p className="text-xs text-mp-gray" data-id="element-263" data-mp="1zcbmtx97c5kv">Desde 16,90 €</p>
            </div>
            <a href="#oferta" className="flex-shrink-0 rounded-lg bg-mp-lime px-4 py-2.5 font-heading text-xs font-extrabold uppercase text-mp-black transition-transform duration-150 ease-out active:scale-95" data-id="element-264" data-mp="1vb05sg4e8soa">
              Ver oferta
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}